






























































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import AppConsts from '@/lib/appConstants';
import UpdateInstitutionFeaturesRequest from '@/models/Settings/Institutions/UpdateInstitutionFeaturesRequest';

@Component({ name: 'InstitutionThemeEdit' })
export default class extends SaascadaVueDialog {

    AppConsts = AppConsts;
    dialog = false;
    request: UpdateInstitutionFeaturesRequest = new UpdateInstitutionFeaturesRequest();

    @Prop({required: true})
    isLight: boolean;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateInstitutionFeaturesRequest();
        }
    }

    async cancel() {
        this.dialog = false;
    }

    async save() {
        this.dialog = false;
    }

}
